module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!this.authorized && _vm.dataLoaded) ? _c('div', [_vm._v("\nIkke logget ind\n")]) : _vm._e(), _vm._v(" "), (this.authorized) ? _c('div', [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    class: {
      active: _vm.activeTab == 'activities'
    },
    on: {
      "click": function($event) {
        return _vm.setActiveTab('activities')
      }
    }
  }, [_vm._v("Aktiviteter")]), _vm._v(" "), _c('div', {
    class: {
      active: _vm.activeTab == 'create-activity'
    },
    on: {
      "click": function($event) {
        return _vm.setActiveTab('create-activity')
      }
    }
  }, [_vm._v("Opret Aktivitet")]), _vm._v(" "), _c('div', {
    class: {
      active: _vm.activeTab == 'series'
    },
    on: {
      "click": function($event) {
        return _vm.setActiveTab('series')
      }
    }
  }, [_vm._v("Serier")]), _vm._v(" "), _c('div', {
    class: {
      active: _vm.activeTab == 'create-series'
    },
    on: {
      "click": function($event) {
        return _vm.setActiveTab('create-series')
      }
    }
  }, [_vm._v("Opret Serie")]), _vm._v(" "), _c('div', {
    class: {
      active: _vm.activeTab == 'contact'
    },
    on: {
      "click": function($event) {
        return _vm.setActiveTab('contact')
      }
    }
  }, [_vm._v("Kontakt")]), _vm._v(" "), _c('div', {
    attrs: {
      "onclick": "window.open('https://console.firebase.google.com/project/hscamping-9c323/notification', '_blank')"
    }
  }, [_vm._v("Push-beskeder")]), _vm._v(" "), _c('div', {
    class: {
      active: _vm.activeTab == 'settings'
    },
    on: {
      "click": function($event) {
        return _vm.setActiveTab('settings')
      }
    }
  }, [_vm._v("Indstillinger")])]), _vm._v(" "), (_vm.activeTab == 'activities') ? _c('div', {
    staticClass: "search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSearch),
      expression: "currentSearch"
    }],
    attrs: {
      "placeholder": "søg",
      "type": "text"
    },
    domProps: {
      "value": (_vm.currentSearch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentSearch = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "flatpickr-placeholder"
  }, [_vm._v("vælg dato-interval")]), _vm._v(" "), _c('Flatpickr', {
    ref: "flatpickr",
    attrs: {
      "options": _vm.fpOptionsRange,
      "placeholder": "vælg dato-interval"
    },
    model: {
      value: (_vm.currentDate),
      callback: function($$v) {
        _vm.currentDate = $$v
      },
      expression: "currentDate"
    }
  }), _vm._v(" "), (_vm.currentDate) ? _c('img', {
    attrs: {
      "src": require("../assets/calendar.svg"),
      "alt": "nulstil kalender"
    },
    on: {
      "click": _vm.resetCurrentDate
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab == 'activities') ? _c('div', [(_vm.currentDateRange && _vm.currentDateRange.from && _vm.currentDateRange.to) ? _c('h2', [_vm._v(_vm._s(_vm._f("localizeDateSimple")(_vm.currentDateRange.from)) + " - " + _vm._s(_vm._f("localizeDateSimple")(_vm.currentDateRange.to)))]) : _vm._e(), _vm._v(" "), (_vm.currentDate === '') ? _c('h2', [_vm._v(_vm._s(_vm._f("localizeDateSimple")(_vm.today)) + " - " + _vm._s(_vm._f("localizeDateSimple")(_vm.aMonthFromNow)))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.dates), function(date) {
    return _c('div', {
      staticClass: "date"
    }, [_c('div', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(_vm._f("localizeDate")(date)))]), _vm._v(" "), _vm._l((_vm.filter(_vm.getActivities(date))), function(activity) {
      return _c('div', {
        staticClass: "activity",
        class: {
          past: _vm.isPastActivity(activity)
        }
      }, [_c('img', {
        attrs: {
          "src": activity.pic,
          "alt": "aktivitet"
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "content"
      }, [_c('div', {
        staticClass: "title"
      }, [_vm._v(_vm._s(activity.title[_vm.currentLang]))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("minutesToTimeOfDay")(activity.startTimeInMinutes)) + " - " + _vm._s(_vm._f("minutesToTimeOfDay")(activity.endTimeInMinutes)))]), _vm._v(" "), _c('div', {
        staticClass: "about"
      },[_vm._v(_vm._s(activity.about[_vm.currentLang]))]), _vm._v(" "), _c('div', [_c('span', {
        staticClass: "edit",
        on: {
          "click": function($event) {
            return _vm.edit(activity)
          }
        }
      }, [_vm._v("rediger")]), _vm._v(" "), (activity.title['da']) ? _c('span', {
        staticClass: "translated-da"
      }, [_vm._v("DA")]) : _vm._e(), _vm._v(" "), (activity.title['de']) ? _c('span', {
        staticClass: "translated-de"
      }, [_vm._v("DE")]) : _vm._e(), _vm._v(" "), (activity.series) ? _c('span', {
        staticClass: "series",
        on: {
          "click": function($event) {
            _vm.editSeries(_vm.getSeries(activity.series))
          }
        }
      }, [_vm._v("serie")]) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "delete",
        on: {
          "click": function($event) {
            return _vm.deleteActivityModal(activity)
          }
        }
      }, [_vm._v("slet")])])])])
    })], 2)
  }), _vm._v(" "), (!_vm.dataLoaded) ? _c('div', {
    staticClass: "spinner"
  }) : _vm._e(), _vm._v(" "), ((_vm.dataLoaded && _vm.dates && _vm.dates.length === 0 && _vm.currentDate !== '') || (_vm.currentDate === '' && _vm.dataLoaded && _vm.dates.length === 0)) ? _c('div', [_vm._v("Ingen aktiviteter")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.activeTab == 'edit-activity' || _vm.activeTab == 'edit-series') ? _c('div', [(_vm.activeActivity || _vm.activeSeries) ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('table', {
    staticClass: "edit-activity"
  }, [_c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputLanguage.title),
      expression: "inputLanguage.title"
    }],
    staticClass: "lang-dropdown",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.inputLanguage, "title", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "da"
    }
  }, [_vm._v("Titel (dansk)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "de"
    }
  }, [_vm._v("Titel (tysk)")])])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeActivity.title[_vm.inputLanguage.title]),
      expression: "activeActivity.title[inputLanguage.title]"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.activeActivity.title[_vm.inputLanguage.title])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activeActivity.title, _vm.inputLanguage.title, $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputLanguage.about),
      expression: "inputLanguage.about"
    }],
    staticClass: "lang-dropdown",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.inputLanguage, "about", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "da"
    }
  }, [_vm._v("Kort beskrivelse (dansk)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "de"
    }
  }, [_vm._v("Kort beskrivelse (tysk)")])])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeActivity.about[_vm.inputLanguage.about]),
      expression: "activeActivity.about[inputLanguage.about]"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.activeActivity.about[_vm.inputLanguage.about])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activeActivity.about, _vm.inputLanguage.about, $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'edit-activity'),
      expression: "activeTab == 'edit-activity'"
    }]
  }, [_c('td', [_vm._v("Dato")]), _c('td', [_c('Flatpickr', {
    attrs: {
      "options": _vm.fpOptions
    },
    model: {
      value: (_vm.activeActivity.date),
      callback: function($$v) {
        _vm.$set(_vm.activeActivity, "date", $$v)
      },
      expression: "activeActivity.date"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Starttidspunkt")]), _vm._v(" "), _c('td', [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm",
      "minute-interval": 15,
      "hide-clear-button": ""
    },
    on: {
      "change": _vm.onActiveActivityStartTimeChanged
    },
    model: {
      value: (_vm.activeActivityStartTime),
      callback: function($$v) {
        _vm.activeActivityStartTime = $$v
      },
      expression: "activeActivityStartTime"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Sluttidspunkt")]), _vm._v(" "), _c('td', [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm",
      "minute-interval": 15,
      "hide-clear-button": ""
    },
    on: {
      "change": _vm.onActiveActivityEndTimeChanged
    },
    model: {
      value: (_vm.activeActivityEndTime),
      callback: function($$v) {
        _vm.activeActivityEndTime = $$v
      },
      expression: "activeActivityEndTime"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputLanguage.location),
      expression: "inputLanguage.location"
    }],
    staticClass: "lang-dropdown",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.inputLanguage, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "da"
    }
  }, [_vm._v("Sted (dansk)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "de"
    }
  }, [_vm._v("Sted (tysk)")])])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeActivity.location[_vm.inputLanguage.location]),
      expression: "activeActivity.location[inputLanguage.location]"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.activeActivity.location[_vm.inputLanguage.location])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activeActivity.location, _vm.inputLanguage.location, $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Arrangør")]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeActivity.organiser),
      expression: "activeActivity.organiser"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.activeActivity.organiser)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activeActivity, "organiser", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Maks antal pladser")]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeActivity.maxAmountOfParticipants),
      expression: "activeActivity.maxAmountOfParticipants"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.activeActivity.maxAmountOfParticipants)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activeActivity, "maxAmountOfParticipants", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputLanguage.info),
      expression: "inputLanguage.info"
    }],
    staticClass: "lang-dropdown",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.inputLanguage, "info", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "da"
    }
  }, [_vm._v("Info (dansk)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "de"
    }
  }, [_vm._v("Info (tysk)")])])]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeActivity.info[_vm.inputLanguage.info]),
      expression: "activeActivity.info[inputLanguage.info]"
    }],
    attrs: {
      "rows": "6",
      "cols": "40"
    },
    domProps: {
      "value": (_vm.activeActivity.info[_vm.inputLanguage.info])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activeActivity.info, _vm.inputLanguage.info, $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('table', {
    staticClass: "edit-activity"
  }, [_c('tr', [_c('td', [_vm._v("Billede")]), _vm._v(" "), _c('td', [_c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onActiveActivityFileChange
    }
  }), _vm._v(" "), (!_vm.activeActivityPreviewImage) ? _c('img', {
    staticClass: "preview",
    attrs: {
      "src": _vm.activeActivity.pic,
      "alt": "aktivitet"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeActivityPreviewImage) ? _c('img', {
    staticClass: "preview",
    attrs: {
      "src": _vm.activeActivityPreviewImage,
      "alt": "aktivitet"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Synlig for")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeActivity.visibleTo),
      expression: "activeActivity.visibleTo"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.activeActivity, "visibleTo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "everyone"
    }
  }, [_vm._v("Alle")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "camping"
    }
  }, [_vm._v("Kun HS Camping gæster")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "partner"
    }
  }, [_vm._v("Kun FP gæster")])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Hvem")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeActivity.who),
      expression: "activeActivity.who"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.activeActivity, "who", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Intet valgt")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "children"
    }
  }, [_vm._v("Børn")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "adults"
    }
  }, [_vm._v("Voksne")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "family"
    }
  }, [_vm._v("Hele familien")])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Hvor")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeActivity.where),
      expression: "activeActivity.where"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.activeActivity, "where", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Intet valgt")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "indoors"
    }
  }, [_vm._v("Indendørs")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "outdoors"
    }
  }, [_vm._v("Udendørs")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cafehav"
    }
  }, [_vm._v("Café HAV")])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Hvad")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeActivity.what),
      expression: "activeActivity.what"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.activeActivity, "what", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Intet valgt")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "sport"
    }
  }, [_vm._v("Sport")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "nature"
    }
  }, [_vm._v("Natur")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "creative"
    }
  }, [_vm._v("Kreativ")])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Pris-kategori")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeActivity.priceCategory),
      expression: "activeActivity.priceCategory"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.activeActivity, "priceCategory", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "freeForAll"
    }
  }, [_vm._v("Gratis for alle")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "freeWithPackage"
    }
  }, [_vm._v("Gratis med aktivitetspakke")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "paying"
    }
  }, [_vm._v("Betalende")])])])]), _vm._v(" "), (_vm.activeActivity.priceCategory !== 'freeForAll') ? _c('tr', [_c('td', [_vm._v("Pris (DKK)")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeActivity.price),
      expression: "activeActivity.price"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.activeActivity.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activeActivity, "price", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Kategori")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeActivity.category),
      expression: "activeActivity.category"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.activeActivity, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "free"
    }
  }, [_vm._v("Ikke bindende tilmelding")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "binding"
    }
  }, [_vm._v("Bindende tilmelding")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "offSite"
    }
  }, [_vm._v("Udenfor pladsen")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hereAndNow"
    }
  }, [_vm._v("Her&Nu betaling")])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Push-beskeder")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeActivity.pushNotificationMinInAdvance),
      expression: "activeActivity.pushNotificationMinInAdvance"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.activeActivity, "pushNotificationMinInAdvance", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Ingen")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v("15 min før")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v("30 min før")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "45"
    }
  }, [_vm._v("45 min før")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "60"
    }
  }, [_vm._v("1 time før")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "90"
    }
  }, [_vm._v("1½ time før")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "120"
    }
  }, [_vm._v("2 timer før")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "150"
    }
  }, [_vm._v("2½ timer før")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "180"
    }
  }, [_vm._v("3 timer før")])])])])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'edit-activity'),
      expression: "activeTab == 'edit-activity'"
    }],
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.updateActiveActivityModal
    }
  }, [_vm._v("Gem ændringer")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'edit-series'),
      expression: "activeTab == 'edit-series'"
    }],
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.updateActiveSeriesModal
    }
  }, [_vm._v("Gem ændringer")]), _vm._v(" "), (_vm.updatingActiveActivity) ? _c('div', {
    staticClass: "spinner"
  }) : _vm._e(), _vm._v(" "), (_vm.activeActivityUpdated && _vm.activeTab == 'edit-activity') ? _c('div', [_vm._v("ændringer gemt")]) : _vm._e(), _vm._v(" "), (_vm.activeActivityUpdated && _vm.activeTab == 'edit-series') ? _c('div', [_vm._v("ændringer gemt")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'edit-activity'),
      expression: "activeTab == 'edit-activity'"
    }]
  }, [_c('h2', [_vm._v("Deltagerliste (" + _vm._s(_vm.getParticipantsAmount(_vm.activeActivity))), (_vm.getMaxAmountOfParticipants(_vm.activeActivity) != null) ? _c('span', [_vm._v("/" + _vm._s(_vm.getMaxAmountOfParticipants(_vm.activeActivity)))]) : _vm._e(), _vm._v(")")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participantToAdd),
      expression: "participantToAdd"
    }],
    staticClass: "addParticipant",
    attrs: {
      "type": "text",
      "placeholder": "navn"
    },
    domProps: {
      "value": (_vm.participantToAdd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.participantToAdd = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.addParticipantModal()
      }
    }
  }, [_vm._v("Tilføj")]), _vm._v(" "), (_vm.showTooManyParticipants) ? _c('div', [_vm._v("Deltagerbegrænsning overskredet")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "participants"
  }, _vm._l((_vm.getParticipants(_vm.activeActivity)), function(participant) {
    return _c('div', {
      staticClass: "participant",
      class: {
        confirmed: participant.confirmed
      },
      on: {
        "click": function($event) {
          return _vm.confirmParticipantModal(participant, _vm.activeActivity, !participant.confirmed)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(participant.name))]), (participant.email) ? _c('span', [_vm._v("(" + _vm._s(participant.email) + ")")]) : _vm._e(), (participant.guestOn) ? _c('span', [_vm._v("- " + _vm._s(_vm.displayGuestOn(participant.guestOn)))]) : _vm._e(), (participant.guestOn) ? _c('span', [_vm._v("("), _c('img', {
      attrs: {
        "src": require("../assets/smartphone.svg"),
        "height": "18"
      }
    }), _vm._v(")")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "removeButton",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeParticipantModal(participant, _vm.activeActivity)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../assets/close.svg"),
        "width": "17"
      }
    })])])
  }), 0), _vm._v(" "), (!_vm.getParticipants(_vm.activeActivity)) ? _c('div', [_vm._v("Ingen deltagere")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.activeTab == 'create-activity' || _vm.activeTab == 'create-series') ? _c('div', [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('table', {
    staticClass: "edit-activity"
  }, [_c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputLanguage.title),
      expression: "inputLanguage.title"
    }],
    staticClass: "lang-dropdown",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.inputLanguage, "title", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "da"
    }
  }, [_vm._v("Titel (dansk)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "de"
    }
  }, [_vm._v("Titel (tysk)")])])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.title[_vm.inputLanguage.title]),
      expression: "newActivity.title[inputLanguage.title]"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newActivity.title[_vm.inputLanguage.title])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newActivity.title, _vm.inputLanguage.title, $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputLanguage.about),
      expression: "inputLanguage.about"
    }],
    staticClass: "lang-dropdown",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.inputLanguage, "about", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "da"
    }
  }, [_vm._v("Kort beskrivelse (dansk)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "de"
    }
  }, [_vm._v("Kort beskrivelse (tysk)")])])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.about[_vm.inputLanguage.about]),
      expression: "newActivity.about[inputLanguage.about]"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newActivity.about[_vm.inputLanguage.about])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newActivity.about, _vm.inputLanguage.about, $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'create-activity'),
      expression: "activeTab == 'create-activity'"
    }]
  }, [_c('td', [_vm._v("Dato")]), _c('td', [_c('Flatpickr', {
    attrs: {
      "options": _vm.fpOptions
    },
    model: {
      value: (_vm.newActivity.date),
      callback: function($$v) {
        _vm.$set(_vm.newActivity, "date", $$v)
      },
      expression: "newActivity.date"
    }
  })], 1)]), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'create-series'),
      expression: "activeTab == 'create-series'"
    }]
  }, [_c('td', [_vm._v("Startdato")]), _c('td', [_c('Flatpickr', {
    attrs: {
      "options": _vm.fpOptions
    },
    model: {
      value: (_vm.newActivity.startDate),
      callback: function($$v) {
        _vm.$set(_vm.newActivity, "startDate", $$v)
      },
      expression: "newActivity.startDate"
    }
  })], 1)]), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'create-series'),
      expression: "activeTab == 'create-series'"
    }]
  }, [_c('td', [_vm._v("Slutdato")]), _c('td', [_c('Flatpickr', {
    attrs: {
      "options": _vm.fpOptions
    },
    model: {
      value: (_vm.newActivity.endDate),
      callback: function($$v) {
        _vm.$set(_vm.newActivity, "endDate", $$v)
      },
      expression: "newActivity.endDate"
    }
  })], 1)]), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'create-series'),
      expression: "activeTab == 'create-series'"
    }]
  }, [_c('td', [_vm._v("Gentag")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.repeat),
      expression: "newActivity.repeat"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newActivity, "repeat", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "daily"
    }
  }, [_vm._v("Daglig")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "weekly"
    }
  }, [_vm._v("Ugentlig")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "monthly"
    }
  }, [_vm._v("Månedlig")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newActivity.repeat === 'weekly' || _vm.newActivity.repeat === 'monthly'),
      expression: "newActivity.repeat === 'weekly' || newActivity.repeat === 'monthly'"
    }],
    staticClass: "repeatDays"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newActivity.repeat === 'monthly'),
      expression: "newActivity.repeat === 'monthly'"
    }]
  }, [_vm._v("Første")]), _vm._v(" "), _c('div', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.repeatDays),
      expression: "newActivity.repeatDays"
    }],
    attrs: {
      "type": "checkbox",
      "value": "0"
    },
    domProps: {
      "checked": Array.isArray(_vm.newActivity.repeatDays) ? _vm._i(_vm.newActivity.repeatDays, "0") > -1 : (_vm.newActivity.repeatDays)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newActivity.repeatDays,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "0",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newActivity, "repeatDays", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newActivity, "repeatDays", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newActivity, "repeatDays", $$c)
        }
      }
    }
  }), _vm._v("man")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.repeatDays),
      expression: "newActivity.repeatDays"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.newActivity.repeatDays) ? _vm._i(_vm.newActivity.repeatDays, "1") > -1 : (_vm.newActivity.repeatDays)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newActivity.repeatDays,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newActivity, "repeatDays", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newActivity, "repeatDays", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newActivity, "repeatDays", $$c)
        }
      }
    }
  }), _vm._v("tir")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.repeatDays),
      expression: "newActivity.repeatDays"
    }],
    attrs: {
      "type": "checkbox",
      "value": "2"
    },
    domProps: {
      "checked": Array.isArray(_vm.newActivity.repeatDays) ? _vm._i(_vm.newActivity.repeatDays, "2") > -1 : (_vm.newActivity.repeatDays)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newActivity.repeatDays,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "2",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newActivity, "repeatDays", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newActivity, "repeatDays", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newActivity, "repeatDays", $$c)
        }
      }
    }
  }), _vm._v("ons")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.repeatDays),
      expression: "newActivity.repeatDays"
    }],
    attrs: {
      "type": "checkbox",
      "value": "3"
    },
    domProps: {
      "checked": Array.isArray(_vm.newActivity.repeatDays) ? _vm._i(_vm.newActivity.repeatDays, "3") > -1 : (_vm.newActivity.repeatDays)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newActivity.repeatDays,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "3",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newActivity, "repeatDays", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newActivity, "repeatDays", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newActivity, "repeatDays", $$c)
        }
      }
    }
  }), _vm._v("tor")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.repeatDays),
      expression: "newActivity.repeatDays"
    }],
    attrs: {
      "type": "checkbox",
      "value": "4"
    },
    domProps: {
      "checked": Array.isArray(_vm.newActivity.repeatDays) ? _vm._i(_vm.newActivity.repeatDays, "4") > -1 : (_vm.newActivity.repeatDays)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newActivity.repeatDays,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "4",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newActivity, "repeatDays", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newActivity, "repeatDays", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newActivity, "repeatDays", $$c)
        }
      }
    }
  }), _vm._v("fre")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.repeatDays),
      expression: "newActivity.repeatDays"
    }],
    attrs: {
      "type": "checkbox",
      "value": "5"
    },
    domProps: {
      "checked": Array.isArray(_vm.newActivity.repeatDays) ? _vm._i(_vm.newActivity.repeatDays, "5") > -1 : (_vm.newActivity.repeatDays)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newActivity.repeatDays,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "5",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newActivity, "repeatDays", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newActivity, "repeatDays", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newActivity, "repeatDays", $$c)
        }
      }
    }
  }), _vm._v("lør")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.repeatDays),
      expression: "newActivity.repeatDays"
    }],
    attrs: {
      "type": "checkbox",
      "value": "6"
    },
    domProps: {
      "checked": Array.isArray(_vm.newActivity.repeatDays) ? _vm._i(_vm.newActivity.repeatDays, "6") > -1 : (_vm.newActivity.repeatDays)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newActivity.repeatDays,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "6",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newActivity, "repeatDays", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newActivity, "repeatDays", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newActivity, "repeatDays", $$c)
        }
      }
    }
  }), _vm._v("søn")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newActivity.repeat === 'monthly'),
      expression: "newActivity.repeat === 'monthly'"
    }]
  }, [_vm._v("i hver måned")])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Starttidspunkt")]), _vm._v(" "), _c('td', [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm",
      "minute-interval": 15,
      "hide-clear-button": ""
    },
    model: {
      value: (_vm.newActivity.startTime),
      callback: function($$v) {
        _vm.$set(_vm.newActivity, "startTime", $$v)
      },
      expression: "newActivity.startTime"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Sluttidspunkt")]), _vm._v(" "), _c('td', [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm",
      "minute-interval": 15,
      "hide-clear-button": ""
    },
    model: {
      value: (_vm.newActivity.endTime),
      callback: function($$v) {
        _vm.$set(_vm.newActivity, "endTime", $$v)
      },
      expression: "newActivity.endTime"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputLanguage.location),
      expression: "inputLanguage.location"
    }],
    staticClass: "lang-dropdown",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.inputLanguage, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "da"
    }
  }, [_vm._v("Sted (dansk)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "de"
    }
  }, [_vm._v("Sted (tysk)")])])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.location[_vm.inputLanguage.location]),
      expression: "newActivity.location[inputLanguage.location]"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newActivity.location[_vm.inputLanguage.location])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newActivity.location, _vm.inputLanguage.location, $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Arrangør")]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.organiser),
      expression: "newActivity.organiser"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newActivity.organiser)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newActivity, "organiser", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Maks antal pladser")]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.maxAmountOfParticipants),
      expression: "newActivity.maxAmountOfParticipants"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.newActivity.maxAmountOfParticipants)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newActivity, "maxAmountOfParticipants", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputLanguage.info),
      expression: "inputLanguage.info"
    }],
    staticClass: "lang-dropdown",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.inputLanguage, "info", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "da"
    }
  }, [_vm._v("Info (dansk)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "de"
    }
  }, [_vm._v("Info (tysk)")])])]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.info[_vm.inputLanguage.info]),
      expression: "newActivity.info[inputLanguage.info]"
    }],
    attrs: {
      "rows": "6",
      "cols": "40"
    },
    domProps: {
      "value": (_vm.newActivity.info[_vm.inputLanguage.info])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newActivity.info, _vm.inputLanguage.info, $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('table', {
    staticClass: "edit-activity"
  }, [_c('tr', [_c('td', [_vm._v("Billede")]), _vm._v(" "), _c('td', [_c('input', {
    ref: "newActivityFile",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), (_vm.previewImage) ? _c('img', {
    staticClass: "preview",
    attrs: {
      "src": _vm.previewImage,
      "alt": "aktivitet"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Synlig for")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.visibleTo),
      expression: "newActivity.visibleTo"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newActivity, "visibleTo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "everyone"
    }
  }, [_vm._v("Alle")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "camping"
    }
  }, [_vm._v("Kun HS Camping gæster")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "partner"
    }
  }, [_vm._v("Kun FP gæster")])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Hvem")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.who),
      expression: "newActivity.who"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newActivity, "who", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Intet valgt")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "children"
    }
  }, [_vm._v("Børn")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "adults"
    }
  }, [_vm._v("Voksne")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "family"
    }
  }, [_vm._v("Hele familien")])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Hvor")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.where),
      expression: "newActivity.where"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newActivity, "where", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Intet valgt")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "indoors"
    }
  }, [_vm._v("Indendørs")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "outdoors"
    }
  }, [_vm._v("Udendørs")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cafehav"
    }
  }, [_vm._v("Café HAV")])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Hvad")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.what),
      expression: "newActivity.what"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newActivity, "what", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Intet valgt")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "sport"
    }
  }, [_vm._v("Sport")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "nature"
    }
  }, [_vm._v("Natur")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "creative"
    }
  }, [_vm._v("Kreativ")])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Pris-kategori")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.priceCategory),
      expression: "newActivity.priceCategory"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newActivity, "priceCategory", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "freeForAll"
    }
  }, [_vm._v("Gratis for alle")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "freeWithPackage"
    }
  }, [_vm._v("Gratis med aktivitetspakke")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "paying"
    }
  }, [_vm._v("Betalende")])])])]), _vm._v(" "), (_vm.newActivity.priceCategory !== 'freeForAll') ? _c('tr', [_c('td', [_vm._v("Pris (DKK)")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.price),
      expression: "newActivity.price"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.newActivity.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newActivity, "price", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Kategori")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.category),
      expression: "newActivity.category"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newActivity, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "free"
    }
  }, [_vm._v("Ikke bindende tilmelding")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "binding"
    }
  }, [_vm._v("Bindende tilmelding")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "offSite"
    }
  }, [_vm._v("Udenfor pladsen")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hereAndNow"
    }
  }, [_vm._v("Her&Nu betaling")])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Push-beskeder")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.pushNotificationMinInAdvance),
      expression: "newActivity.pushNotificationMinInAdvance"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newActivity, "pushNotificationMinInAdvance", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Ingen")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v("15 min før")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v("30 min før")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "45"
    }
  }, [_vm._v("45 min før")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "60"
    }
  }, [_vm._v("1 time før")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "90"
    }
  }, [_vm._v("1½ time før")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "120"
    }
  }, [_vm._v("2 timer før")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "150"
    }
  }, [_vm._v("2½ timer før")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "180"
    }
  }, [_vm._v("3 timer før")])])])])])]), _vm._v(" "), _c('div', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'create-activity'),
      expression: "activeTab == 'create-activity'"
    }],
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.createActivityModal
    }
  }, [_vm._v("Opret aktivitet")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'create-series'),
      expression: "activeTab == 'create-series'"
    }],
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.createSeriesModal
    }
  }, [_vm._v("Opret serie")]), _vm._v(" "), (!_vm.submittable && _vm.submitAttempt) ? _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Vælg et billede!")]) : _vm._e(), _vm._v(" "), (_vm.noActivitiesInSeries) ? _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Serien indeholder ingen aktiviteter!")]) : _vm._e(), _vm._v(" "), (_vm.creatingActivity) ? _c('div', {
    staticClass: "spinner"
  }) : _vm._e(), _vm._v(" "), (_vm.activityCreated) ? _c('div', [_vm._v("Aktivitet oprettet")]) : _vm._e(), _vm._v(" "), (_vm.seriesCreated) ? _c('div', [_vm._v("Serie oprettet")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'series') ? _c('div', [_vm._l((_vm.series), function(series) {
    return (series.activities) ? _c('div', {
      staticClass: "date",
      staticStyle: {
        "margin-bottom": "20px"
      }
    }, [_c('div', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(_vm._f("localizeDateSimple")(series.startDate)) + " - " + _vm._s(_vm._f("localizeDateSimple")(series.endDate)) + ", " + _vm._s(_vm.mapRepeatToReadableRepeat(series.repeat)))]), _vm._v(" "), (series.repeat === 'weekly' || series.repeat === 'monthly') ? _c('div', {
      staticStyle: {
        "margin-top": "5px"
      }
    }, [_c('span', [_vm._v("Gentages ")]), (series.repeat === 'monthly') ? _c('span', [_vm._v(" første ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.mapRepeatDaysToReadableDays(series.repeatDays)), function(repeatDay, index) {
      return _c('span', [(index != 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(repeatDay))])
    }), _vm._v(" "), (series.repeat === 'monthly') ? _c('span', [_vm._v("i hver måned")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.getActivity(_vm.getFirstActivityKey(series))) ? _c('div', {
      staticClass: "activity",
      staticStyle: {
        "margin-top": "5px"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getActivity(_vm.getFirstActivityKey(series)).pic,
        "alt": "aktivitet"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.getActivity(_vm.getFirstActivityKey(series)).title[_vm.currentLang]))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("minutesToTimeOfDay")(_vm.getActivity(_vm.getFirstActivityKey(series)).startTimeInMinutes)) + " - " + _vm._s(_vm._f("minutesToTimeOfDay")(_vm.getActivity(_vm.getFirstActivityKey(series)).endTimeInMinutes)))]), _vm._v(" "), _c('div', {
      staticClass: "about"
    }, [_vm._v(_vm._s(_vm.getActivity(_vm.getFirstActivityKey(series)).about[_vm.currentLang]))]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "edit",
      on: {
        "click": function($event) {
          return _vm.editSeries(series)
        }
      }
    }, [_vm._v("rediger")]), _vm._v(" "), (_vm.getActivity(_vm.getFirstActivityKey(series)).title['da']) ? _c('span', {
      staticClass: "translated-da"
    }, [_vm._v("DA")]) : _vm._e(), _vm._v(" "), (_vm.getActivity(_vm.getFirstActivityKey(series)).title['de']) ? _c('span', {
      staticClass: "translated-de"
    }, [_vm._v("DE")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          return _vm.deleteSeriesModal(series)
        }
      }
    }, [_vm._v("slet")])])])]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(Object.keys(series.activities).length) + " aktiviteter i serie")])]) : _vm._e()
  }), _vm._v(" "), (_vm.series && _vm.series.length === 0) ? _c('div', [_vm._v("Ingen serier")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.activeTab == 'contact') ? _c('div', [(_vm.contact) ? _c('table', [_c('tr', [_c('td', [_vm._v("\n                    Kontakt info\n                ")]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.info),
      expression: "contact.info"
    }],
    attrs: {
      "rows": "8",
      "cols": "40"
    },
    domProps: {
      "value": (_vm.contact.info)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "info", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.updateContact
    }
  }, [_vm._v("Gem ændringer")]), _vm._v(" "), (_vm.contactUpdated) ? _c('div', [_vm._v("ændringer gemt")]) : _vm._e()])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.activeTab == 'push-notifications') ? _c('div') : _vm._e(), _vm._v(" "), (_vm.activeTab == 'settings') ? _c('div', [_c('button', {
    on: {
      "click": _vm.deleteOldActivities
    }
  }, [_vm._v("Slet gamle aktiviteter")]), _vm._v(" "), _c('div', [_vm._v("(mere end en måned gamle)")]), _vm._v(" "), (_vm.deletingOldActivities) ? _c('div', {
    staticClass: "spinner"
  }) : _vm._e(), _vm._v(" "), (_vm.oldActivitiesDeleted) ? _c('div', [_vm._v("Gamle aktiviteter slettet")]) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v("Pop-up beskeder ved aktivitet-tilmelding")]), _vm._v(" "), _c('table', {
    staticClass: "edit-activity"
  }, [_c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signupNotesInputLanguage.hereAndNow),
      expression: "signupNotesInputLanguage.hereAndNow"
    }],
    staticClass: "lang-dropdown",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.signupNotesInputLanguage, "hereAndNow", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "da"
    }
  }, [_vm._v("Her&Nu betaling (dansk)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "de"
    }
  }, [_vm._v("Her&Nu betaling (tysk)")])])]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signupNotes.hereAndNow[_vm.signupNotesInputLanguage.hereAndNow]),
      expression: "signupNotes.hereAndNow[signupNotesInputLanguage.hereAndNow]"
    }],
    attrs: {
      "rows": "8",
      "cols": "40"
    },
    domProps: {
      "value": (_vm.signupNotes.hereAndNow[_vm.signupNotesInputLanguage.hereAndNow])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.signupNotes.hereAndNow, _vm.signupNotesInputLanguage.hereAndNow, $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signupNotesInputLanguage.binding),
      expression: "signupNotesInputLanguage.binding"
    }],
    staticClass: "lang-dropdown",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.signupNotesInputLanguage, "binding", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "da"
    }
  }, [_vm._v("Bindende tilmelding (dansk)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "de"
    }
  }, [_vm._v("Bindende tilmelding (tysk)")])])]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signupNotes.binding[_vm.signupNotesInputLanguage.binding]),
      expression: "signupNotes.binding[signupNotesInputLanguage.binding]"
    }],
    attrs: {
      "rows": "8",
      "cols": "40"
    },
    domProps: {
      "value": (_vm.signupNotes.binding[_vm.signupNotesInputLanguage.binding])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.signupNotes.binding, _vm.signupNotesInputLanguage.binding, $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signupNotesInputLanguage.free),
      expression: "signupNotesInputLanguage.free"
    }],
    staticClass: "lang-dropdown",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.signupNotesInputLanguage, "free", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "da"
    }
  }, [_vm._v("Ikke bindende tilmelding (dansk)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "de"
    }
  }, [_vm._v("Ikke bindende tilmelding (tysk)")])])]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signupNotes.free[_vm.signupNotesInputLanguage.free]),
      expression: "signupNotes.free[signupNotesInputLanguage.free]"
    }],
    attrs: {
      "rows": "8",
      "cols": "40"
    },
    domProps: {
      "value": (_vm.signupNotes.free[_vm.signupNotesInputLanguage.free])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.signupNotes.free, _vm.signupNotesInputLanguage.free, $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signupNotesInputLanguage.offSite),
      expression: "signupNotesInputLanguage.offSite"
    }],
    staticClass: "lang-dropdown",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.signupNotesInputLanguage, "offSite", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "da"
    }
  }, [_vm._v("Udenfor pladsen (dansk)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "de"
    }
  }, [_vm._v("Udenfor pladsen (tysk)")])])]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signupNotes.offSite[_vm.signupNotesInputLanguage.offSite]),
      expression: "signupNotes.offSite[signupNotesInputLanguage.offSite]"
    }],
    attrs: {
      "rows": "8",
      "cols": "40"
    },
    domProps: {
      "value": (_vm.signupNotes.offSite[_vm.signupNotesInputLanguage.offSite])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.signupNotes.offSite, _vm.signupNotesInputLanguage.offSite, $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.updateSignupNotes
    }
  }, [_vm._v("Gem ændringer")]), _vm._v(" "), (_vm.signupNotesUpdated) ? _c('div', [_vm._v("ændringer gemt")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.modal.show) ? _c('modal', {
    attrs: {
      "ok": _vm.modal.ok,
      "close": _vm.modal.close
    },
    on: {
      "ok": _vm.modal.action,
      "close": function($event) {
        _vm.modal.show = false
      }
    }
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    domProps: {
      "textContent": _vm._s(_vm.modal.header)
    },
    slot: "header"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.modal.body)
    },
    slot: "body"
  })]) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cdbf39c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Activities.vue
// module id = 249
// module chunks = 1